const partners = ['ECEC Colorado', 'Amaze Health', 'Colorado Shines', 'VR Health Savings'];

export default function PartnersFooter() {
  return (
    <footer className="section-partners bg-white py-3">
      <div className="container text-center">
        <p className="text-uppercase ">In partnership with</p>
        <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 gap-md-5" role="list">
          {partners.map((partner) => (
            <span className="partner-logo" role="listitem" key={partner}>
              {partner}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}
